import { cva, type VariantProps } from 'class-variance-authority';

/**
 * Floating panel anchored below its trigger. Dropped from the top, aligned to
 * the trigger's start or end edge. Uses the design-system surface + card radius
 * + the existing fade-in animation.
 */
export const popoverContentVariants = cva(
  'absolute top-full z-50 mt-2 rounded-card border border-border bg-surface shadow-card animate-fade-in',
  {
    variants: {
      align: {
        start: 'left-0 origin-top-left',
        end: 'right-0 origin-top-right',
      },
    },
    defaultVariants: {
      align: 'end',
    },
  },
);

export type PopoverContentProps = VariantProps<typeof popoverContentVariants>;
